import { XDMWrapper, TARGETS } from '@gt-common/event-logger-web';
import { RailsLandingPageSchema } from './railsSchemas';

export const PDT_SCHEMA_LISTING_ID = 167325;

export const PDT_SCHEMA_LISTING_NAME = "mmt_rails_b2c_pdt_client_logging";

export const RAILS_CONSTANTS = {
  PAGE_TYPE: 'funnel',
  PAGE_NAME: 'rails-listing',
  FUNNEL_STEP: 'listing',
  LOB: 'rails',
  LOB_CATEGORY: 'rails',
  TRAVEL_CLASS: 'listing',
  STORE_ID: 'MMT',
  ORGANISATION: 'MMT',
  BU: 'ground_transport',
  TEMPLATE_ID: PDT_SCHEMA_LISTING_ID,
  TOPIC_NAME: PDT_SCHEMA_LISTING_NAME,
  TIMEZONE: 'IST',
  FUNNEL_SOURCE: 'landing',
  COUNTRY: 'India',
  COUNTRY_CODE: 'IN',
  LOCUS_TYPE: 'CITY',
  CATEGORY: 'rails'
};

export const generateUUID = () => {
  let d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const buildPageContext = ({
  pageType = 'funnel',
  pageName,
  funnelStep,
  lob = 'rails',
  lobCategory = 'rails',
}) => ({
  page_type: pageType,
  page_name: pageName,
  funnel_step: funnelStep,
  lob,
  lob_category: lobCategory,
  travel_store: {
    store_id: 'MMT'
  }
});

export const buildSearchContext = ({
  from,
  fromName,
  to,
  toName,
  travelClass,
}) => ({
  from: {
    locus: {
      locus_id: from || '',
      locus_type: 'CITY',
      country: 'India'
    },
    location: {
      code: from || '',
      name: fromName || from || '',
      country_code: 'IN',
      country: 'India'
    }
  },
  to: {
    locus: {
      locus_id: to || '',
      locus_type: 'CITY',
      country: 'India'
    },
    location: {
      code: to || '',
      name: toName || to || '',
      country_code: 'IN',
      country: 'India'
    }
  },
  travel_class: travelClass || 'listing'
});

export const buildEventTrackingContext = ({
  sessionId,
} = {}) => ({
  organisation: 'MMT',
  bu: 'ground_transport',
  env: process.env.NODE_ENV === 'development' ? 'development' : 'production',
  template_id: PDT_SCHEMA_LISTING_ID,
  topic_name: PDT_SCHEMA_LISTING_NAME,
  timezone: 'IST',
  funnel_source: 'listing',
  ...(sessionId && { session_id: sessionId }),
});

export const buildEventDetail = ({
  eventName,
  eventType,
  eventValue,
  components,
  bookingInfo,
  addonDetails,
  travellerInfo,
}) => {
  const detail = {
    event_id: generateUUID(),
    event_timestamp: Date.now(),
    event_name: eventName,
    event_type: eventType,
    event_value: eventValue,
  };

  if (components) {
    detail.components = components;
  }

  if (bookingInfo) {
    detail.booking_info = bookingInfo;
  }

  if (addonDetails) {
    detail.addon_details = addonDetails;
  }

  if (travellerInfo) {
    detail.traveller_info = travellerInfo;
  }

  return detail;
};

export const parseAmount = (amount) => {
  if (typeof amount === 'number') return amount;
  if (typeof amount === 'string') {
    const parsed = parseFloat(amount.replace(/[^0-9.]/g, ''));
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

const XDM_LOG_PREFIX = '[XDM]';
const XDM_TRACKING_DISABLED_MSG = 'Tracking disabled by poku';
const XDM_EVENT_SKIPPED_MSG = 'Skipped - XDM tracking disabled';
const LOB_NAME = 'rails';

export const isXdmTrackingEnabled = (isXdmEnabled) => {
  if (isXdmEnabled === false) {
    console.log(`${XDM_LOG_PREFIX} ${XDM_TRACKING_DISABLED_MSG}`);
    return false;
  }
  return true;
};

export const sendXDMEvent = async ({ payload, eventName = 'XDM Event', isXdmEnabled = false }) => {
  try {
    if (!isXdmTrackingEnabled(isXdmEnabled)) {
      console.log(`[${eventName}] ${XDM_EVENT_SKIPPED_MSG}`);
      return;
    }

    await XDMWrapper.logEvent({
      payload,
      schema: RailsLandingPageSchema,
      otherConfig: {
        lobName: LOB_NAME,
        adobeKeyConfig: []
      },
      target: TARGETS.ALL,
      extraOptions: {
        lob: LOB_NAME,
        destinationUrl: typeof window !== 'undefined' ? window.location.href : ''
      }
    });
  } catch (error) {
    console.error(`[${eventName}] Error:`, error.message);
    throw error;
  }
};

export { TARGETS };
